import { useEffect } from 'react';
import { useCalculatorContext } from '../../contexts';
export function useScrollListToActiveProduct(_ref) {
  var scrollRef = _ref.scrollRef,
    activeRef = _ref.activeRef;
  var _useCalculatorContext = useCalculatorContext(),
    selectedProduct = _useCalculatorContext.selectedProduct,
    products = _useCalculatorContext.products;
  function scrollListToActiveProduct() {
    if (!scrollRef.current) return;
    var activeProduct = activeRef.current;
    var container = scrollRef.current;
    if (!activeProduct) return;
    var activeProductRect = activeProduct.getBoundingClientRect();
    var containerRefRect = container.getBoundingClientRect();
    var currentScrollTop = container.scrollTop;
    var scrollDistance = activeProductRect.top - containerRefRect.top + currentScrollTop - 320 / 2 + 50;
    container.scroll({
      top: scrollDistance,
      behavior: 'smooth'
    });
  }
  useEffect(function () {
    scrollListToActiveProduct();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedProduct, Object.keys(products).length]);
}